var _a;
import { ENVS } from "@adsk/acs-sc-web-platform-api";
// Analytics Events
var PROJECT_TEMPLATE = "project_template";
var CREATE_TEMPLATE = "create_template";
var TEMPLATE_SETTINGS = "template_settings";
var SAVE_AS_TEMPLATE = "save_as_template";
export var CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE = "https://help.autodesk.com/view/BUILD/ENU/?guid=Templates_Included";
export var CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE_CODE_MAP = {
    cs: "CHS",
    da: "DAN",
    de: "DEU",
    en: "ENU",
    "en-GB": "ENG",
    es: "ESP",
    fr: "FRA",
    "fr-CA": "FRC",
    ja: "JPN",
    ko: "KOR",
    nl: "NLD",
    no: "NOR",
    sv: "SWE",
    "zh-Hans": "CHS",
    "zh-Hant": "CHT",
};
export var AnalyticsEvents = {
    createTemplateModal: {
        closeModalFromHeader: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".close_modal.click"),
        nextButton: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".next_button.click"),
        backButton: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".back_button.click"),
        cancelButton: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".cancel_button.click"),
        submitButton: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit_button.click"),
        templateCreateTypeBlank: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".template_create_type_blank.click"),
        templateCreateTypeFromProject: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".template_create_type_from_project.click"),
        selectAccount: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".select_account.click"),
        selectProject: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".select_project.click"),
        submit: {
            duplicateNameError: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit.error.duplicate_name"),
            invalidNameError: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit.error.invalid_name"),
            nameTooLongError: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit.error.name_too_long"),
            otherError: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit.error.other"),
            success: "".concat(PROJECT_TEMPLATE, ".").concat(CREATE_TEMPLATE, ".submit.success"),
        },
    },
    createTemplateInSettingsModal: {
        closeModalFromHeader: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".close"),
        cancelButton: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".cancel"),
        submitButton: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit"),
        submit: {
            duplicateNameError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.duplicate_name"),
            invalidNameError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.invalid_name"),
            nameTooLongError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.name_too_long"),
            otherError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.other"),
            success: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".success"),
        },
    },
    createTemplateGlobalTemplateModal: {
        closeModalFromHeader: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".close"),
        cancelButton: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".cancel"),
        submitButton: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit"),
        submit: {
            duplicateNameError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.duplicate_name"),
            invalidNameError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.invalid_name"),
            nameTooLongError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.name_too_long"),
            otherError: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".submit.error.other"),
            success: "".concat(PROJECT_TEMPLATE, ".").concat(TEMPLATE_SETTINGS, ".").concat(SAVE_AS_TEMPLATE, ".success"),
        },
    },
};
export var ProjectPlatform;
(function (ProjectPlatform) {
    ProjectPlatform["Acc"] = "acc";
    ProjectPlatform["Bim"] = "bim360";
})(ProjectPlatform || (ProjectPlatform = {}));
export var AccountAccessLevel;
(function (AccountAccessLevel) {
    AccountAccessLevel["ProjectAdmin"] = "projectAdmin";
    AccountAccessLevel["AccountAdmin"] = "accountAdmin";
})(AccountAccessLevel || (AccountAccessLevel = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["PL_PROJECT_TEMPLATES_MAINTENANCE_MODE"] = "PL_PROJECT_TEMPLATES_MAINTENANCE_MODE";
})(FeatureFlag || (FeatureFlag = {}));
export var LaunchDarklyIdByEnv = (_a = {},
    _a[ENVS.QA] = "5cfe5a82648b9507525dcb0e",
    _a[ENVS.STAGING] = "5d12565bd7bc9707683c5682",
    _a[ENVS.PRODUCTION] = "5cfe5a817682e907558f568c",
    _a);
export var MAX_PROJECTS_TO_DISPLAY = 200;
